export default __webpack_public_path__ + "static/media/code.5fdee3d7.svg";